export default __webpack_public_path__ + "static/media/unexpected.46ba2ea9.jpeg";